import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { url_servicios } from 'src/app/config/config';
import { ApiService } from './api.service';
import { NoteRbtV2 } from '../models';

type NoteRbtDetailsResponse = {
  provider_name: unknown;
  supervisor_name: string;
  target: number;
  replacements: unknown[];
  maladaptives: unknown[];
  interventions: unknown;
  noteRbt: NoteRbtV2;
};

type GenerateAiSummaryResponse = {
  summary: string;
  [key: string]: unknown;
};

@Injectable({
  providedIn: 'root',
})
export class NoteRbtService extends ApiService<NoteRbtV2> {
  constructor() {
    super(inject(HttpClient), url_servicios + '/note_rbt');
  }

  getNote(id: number): Observable<NoteRbtDetailsResponse> {
    const URL = this.endpoint + '/show/' + id;
    return this.http.get<NoteRbtDetailsResponse>(URL);
  }

  createReplacementNote(data: Record<string, unknown>): Observable<unknown> {
    const URL = url_servicios + '/note_rbt/storeReplacemts';
    return this.http.post<unknown>(URL, data);
  }

  noteUpdateModifier(data: Record<string, unknown>, client_id: number | string): Observable<unknown> {
    const URL = url_servicios + '/note_rbt/update/modifier/' + client_id;
    return this.http.put<unknown>(URL, data);
  }

  showNotebyPatient(patient_id: number | string): Observable<unknown> {
    const URL = url_servicios + '/note_rbt/byprofile/' + patient_id;
    return this.http.get<unknown>(URL);
  }
  showReplacementbyPatient(patient_id: number | string): Observable<unknown> {
    const URL =
      url_servicios + '/note_rbt/showReplacementBypatient/' + patient_id;
    return this.http.get<unknown>(URL);
  }
  showNotebyClient(client_id: number | string): Observable<unknown> {
    const URL = url_servicios + '/note_rbt/byclient/' + client_id;
    return this.http.get<unknown>(URL);
  }

  listConfigNote(): Observable<unknown> {
    const URL = url_servicios + '/note_rbt/config';
    return this.http.get<unknown>(URL);
  }

  updateStatus(data: Record<string, unknown>, client_id: number | string): Observable<unknown> {
    const URL = url_servicios + '/note_rbt/update/status/' + client_id;
    return this.http.put<unknown>(URL, data);
  }

  generateAISummary(data: Record<string, unknown>): Observable<GenerateAiSummaryResponse> {
    const URL = url_servicios + '/note_rbt/generate-summary';
    return this.http.post<GenerateAiSummaryResponse>(URL, data);
  }

  getPdf(note_id: number) {
    const URL = url_servicios + '/v2/note_rbt/pdf/' + note_id;
    return this.http.get(URL, { responseType: 'arraybuffer' });
  }
}
